import type { ApiArticle } from "@/hooks/useArticles";
import type { Article } from "@/types/insights";

const stripHtml = (s: string) => s.replace(/<[^>]*>/g, " ").replace(/\s+/g, " ").trim();

/** Rough reading time from the article body word count (~200 wpm). */
function readingTime(a: ApiArticle): { ar: string; en: string } {
  const words = Math.max(stripHtml(a.body?.en || a.body?.ar || "").split(" ").filter(Boolean).length, 1);
  const min = Math.max(1, Math.round(words / 200));
  return { ar: `${min} دقائق قراءة`, en: `${min} min read` };
}

function fmtDate(iso: string): { ar: string; en: string } {
  const d = iso ? new Date(iso) : null;
  if (!d || Number.isNaN(d.getTime())) return { ar: iso || "", en: iso || "" };
  const opts: Intl.DateTimeFormatOptions = { year: "numeric", month: "long", day: "numeric" };
  return { ar: d.toLocaleDateString("ar-EG", opts), en: d.toLocaleDateString("en-US", opts) };
}

/** Map a backend article to the card/detail display shape. Uses `slug` as the id. */
export function toArticle(a: ApiArticle): Article {
  return {
    id: a.slug,
    category: a.category ?? "",
    date: fmtDate(a.date),
    title: a.title,
    excerpt: a.excerpt,
    readingTime: readingTime(a),
    image: a.cover,
  };
}
